var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { ApplicationContext } from "../../../../ApplicationContext";
import DeleteAssetRemarkCommand from "../../../../commands/assets/DeleteAssetRemarkCommand";
import GetOrganisationAssetsCommand from "../../../../commands/assets/GetOrganisationAssetsCommand";
import UpdateAssetRemarkCommand from "../../../../commands/assets/UpdateAssetRemarkCommand";
import { createErrorResponse } from "../../../../utils/errorUtils";
import { Card, CardBody, CardFooter, Col, Container, Form, Input } from "reactstrap";
import { FormErrorContext } from "../../../../FormErrorContext";
import CardTitleHeader from "../../../components/ui/Cards/CardTitleHeader";
import BasicFormGroup from "../../../components/ui/BasicFormGroup/BasicFormGroup";
import Signals from "../../../../signals/Signals";
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var EditRemarkField = /** @class */ (function (_super) {
    __extends(EditRemarkField, _super);
    /**
     *
     * @param props
     */
    function EditRemarkField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            assetModel: _this.props.assetModel,
            remark: "",
            submitting: false,
            errors: []
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.deleteRemark = _this.deleteRemark.bind(_this);
        return _this;
    }
    /**
     *
     */
    EditRemarkField.prototype.componentDidMount = function () {
        var assetModel = this.props.assetModel;
        this.setState({
            assetModel: assetModel,
            remark: assetModel.properties.remark
        });
    };
    EditRemarkField.prototype.render = function () {
        var intl = this.props.intl;
        var _a = this.state, errors = _a.errors, remark = _a.remark, assetModel = _a.assetModel;
        return (React.createElement(Container, { className: "w-100" },
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'asset.update.remark.overlay.title' }, assetModel.properties) }),
                        React.createElement(CardBody, null,
                            React.createElement(Col, null,
                                React.createElement(BasicFormGroup, null,
                                    React.createElement(Input, { type: "textarea", id: "remark", name: "remark", className: 'form-control form-control-appended', rows: "15", value: remark })))),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "page.labels.save" })))))))));
    };
    /**
     *
     * @param event
     */
    EditRemarkField.prototype.onInputChange = function (event) {
        var remark = event.target.value;
        this.setState({ remark: remark });
    };
    EditRemarkField.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     * @param event
     */
    EditRemarkField.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var intl = this.props.intl;
        var _a = this.state, assetModel = _a.assetModel, remark = _a.remark;
        assetModel.properties.remark = remark;
        if (remark == null || assetModel.properties.remark.length == 0) {
            this.deleteRemark(assetModel);
        }
        else if (assetModel.properties.remark.length > 0) {
            var command = new UpdateAssetRemarkCommand();
            command.execute(assetModel, session.user.organisation.id, intl)
                .then(this.onSuccess)
                .catch(this.onError);
        }
    };
    /**
     *
     * @param event
     */
    EditRemarkField.prototype.deleteRemark = function (assetModel) {
        var session = this.context.session;
        var intl = this.props.intl;
        var command = new DeleteAssetRemarkCommand();
        command.execute(assetModel, session.user.organisation.id, intl)
            .then(this.onSuccess)
            .catch(this.onError);
    };
    /**
     *
     */
    EditRemarkField.prototype.onSuccess = function () {
        this.setState({ errors: null, submitting: true });
        Signals.HideOverlay.dispatch();
        var _a = this.context, session = _a.session, assetCollection = _a.assetCollection;
        var user = session.user;
        var intl = this.props.intl;
        // Refresh assets
        var command = new GetOrganisationAssetsCommand();
        // Do show feedback to the user that getting the assets failed, so the user knows the overview is not the latest overview
        // No need for a .then() since the observer will pick up the changes in the asset collection
        command.execute(user.organisation, assetCollection).catch(function () {
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: "error.assets.getcommand" }), 'danger', true);
        });
        // This has to be called either way, so no need to put this in a .then()
        this.props.refreshMethod();
    };
    /**
     *
     * @param error
     */
    EditRemarkField.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    return EditRemarkField;
}(React.Component));
EditRemarkField.contextType = ApplicationContext;
export default injectIntl(EditRemarkField);
